<div class="reset-password-container">
  <!-- Header -->
  <header class="header">
    <div class="logo">
      <img src="assets/branding/flit-core-logo-light.svg" alt="Flit Core" class="logo-image">
    </div>
  </header>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Illustration -->
    <div class="illustration">
        <i class="fa-solid fa-lock icon-lock"></i>
    </div>

    <!-- Heading -->
    <h1 class="heading">Esqueceu sua senha?</h1>
    
    <!-- Instructions -->
    <p class="instructions">Digite o código de 6 dígitos que enviamos para você</p>

    <!-- Code Input Fields -->
    <div class="code-container">
      <div class="code-inputs">
        <input 
          type="text" 
          class="code-input" 
          [class.filled]="code[0] !== ''"
          maxlength="1" 
          [(ngModel)]="code[0]"
          (input)="onCodeInput($event, 0)"
          (keydown)="onKeyDown($event, 0)"
          #codeInput0>
        <input 
          type="text" 
          class="code-input" 
          [class.filled]="code[1] !== ''"
          maxlength="1" 
          [(ngModel)]="code[1]"
          (input)="onCodeInput($event, 1)"
          (keydown)="onKeyDown($event, 1)"
          #codeInput1>
        <input 
          type="text" 
          class="code-input" 
          [class.filled]="code[2] !== ''"
          maxlength="1" 
          [(ngModel)]="code[2]"
          (input)="onCodeInput($event, 2)"
          (keydown)="onKeyDown($event, 2)"
          #codeInput2>
        <input 
          type="text" 
          class="code-input" 
          [class.filled]="code[3] !== ''"
          maxlength="1" 
          [(ngModel)]="code[3]"
          (input)="onCodeInput($event, 3)"
          (keydown)="onKeyDown($event, 3)"
          #codeInput3>
        <input 
          type="text" 
          class="code-input" 
          [class.filled]="code[4] !== ''"
          maxlength="1" 
          [(ngModel)]="code[4]"
          (input)="onCodeInput($event, 4)"
          (keydown)="onKeyDown($event, 4)"
          #codeInput4>
        <input 
          type="text" 
          class="code-input" 
          [class.filled]="code[5] !== ''"
          maxlength="1" 
          [(ngModel)]="code[5]"
          (input)="onCodeInput($event, 5)"
          (keydown)="onKeyDown($event, 5)"
          #codeInput5>
      </div>
    </div>

    <!-- Password Form -->
    <form [formGroup]="resetPasswordForm" class="password-form">
      <!-- New Password -->
      <div class="input-group">
        <div class="password-input-container">
          <input 
            [type]="showPassword ? 'text' : 'password'"
            class="password-input"
            formControlName="password"
            placeholder="Nova senha"
            [class.error]="submitted && f['password'].errors">
          <button 
            type="button" 
            class="toggle-password" 
            (click)="togglePasswordVisibility()">
            <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <div *ngIf="submitted && f['password'].errors" class="error-text">
          <small *ngIf="f['password'].errors['required']">Senha é obrigatória</small>
          <small *ngIf="f['password'].errors['minlength']">Senha deve ter no mínimo 8 caracteres</small>
          <small *ngIf="f['password'].errors['pattern']">A senha deve incluir maiúscula, minúscula, número e caractere especial</small>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="input-group">
        <div class="password-input-container">
          <input 
            [type]="showConfirmPassword ? 'text' : 'password'"
            class="password-input"
            formControlName="confirmPassword"
            placeholder="Confirmar senha"
            [class.error]="submitted && f['confirmPassword'].errors">
          <button 
            type="button" 
            class="toggle-password" 
            (click)="toggleConfirmPasswordVisibility()">
            <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <div *ngIf="submitted && f['confirmPassword'].errors" class="error-text">
          <small *ngIf="f['confirmPassword'].errors['required']">Confirmação de senha é obrigatória</small>
        </div>
      </div>
    </form>

    <!-- Password Requirements Card -->
    <div class="password-requirements-card" aria-live="polite">
      <div class="prc-header">
        <i class="fas fa-info-circle"></i>
        <span>Requisitos da senha</span>
      </div>
      <ul class="prc-list">
        <li>Pelo menos 8 caracteres</li>
        <li>Uma letra maiúscula</li>
        <li>Uma letra minúscula</li>
        <li>Um número</li>
        <li>Um caractere especial</li>
      </ul>
    </div>


    <!-- Verify Button -->
    <button class="verify-button" (click)="verifyCode()" [disabled]="!isCodeComplete() || isLoading">
      <span *ngIf="!isLoading">Resetar Senha</span>
      <span *ngIf="isLoading">Processando...</span>
    </button>

    <!-- Back to Login Link -->
    <a href="#" class="back-link" (click)="goBack()">
      ← Voltar ao Login
    </a>
  </main>

  <!-- Footer -->
  <footer class="footer">
    <span class="copyright">Copyright©2025</span>
    <a href="#" class="privacy-policy">Sistema de Gestão</a>
  </footer>
</div>
